import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Landing } from "./pages/Landing/Landing.page";
import { TermsOfUse } from "./pages/Terms/Terms.page";

function App() {
  return (
    <div
      style={{
        height: "100%",
      }}
    >
      <Router>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/terms" element={<TermsOfUse />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
